import axios from "axios";
import { API_URL } from "../config";

export const getOrders = () => {
  return fetch("https://dummyjson.com/carts/1").then((res) => res.json());
};

export const getRevenue = () => {
  return fetch("https://dummyjson.com/carts").then((res) => res.json());
};

export const getInventory = () => {
  return fetch("https://dummyjson.com/products").then((res) => res.json());
};

export const getCustomers = () => {
  return fetch("https://dummyjson.com/users").then((res) => res.json());
};
export const getComments = () => {
  return fetch("https://dummyjson.com/comments").then((res) => res.json());
};

//Login API
export const login = async (email, password) => {
  try {
    const response = await axios.post(
      API_URL + `/login`,
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during login!");
  }
};

//Sign up API
export const signUp = async (userObj) => {
  try {
    const response = await axios.post(
      API_URL + `/register`,
      userObj,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during sign up");
  }
};

//Verify OTP
export const verifyOTP = async (userId, otp) => {
  try {
    const response = await axios.post(
      API_URL + `/auth/verify-otp`,
      {
        userId,
        otp,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during verify OTP!");
  }
};

//Verify password
export const verifyPassword = async (userId, password) => {
  try {
    const response = await axios.post(
      API_URL + `/auth/verify-password`,
      {
        userId,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during verify password!");
  }
};

//Verify OTP
export const resendEmailOTP = async (userId) => {
  try {
    const response = await axios.post(
      API_URL + `/auth/resend-email`,
      {
        userId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during resend email otp!");
  }
};

//Authorization user
export const authorizationUser = async (token) => {
  try {
    const response = await axios.get(
      API_URL + '/auth/verify-token',
      {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during verify user!");
  }
};

//get all user
export const view_user_all = async () => {
  try {
    const response = await axios.get(
      API_URL + "/zms/users",
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error occurred during retrieving user:", error);    
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving user");
  }
};

//get all user deleted
export const view_user_all_deleted = async () => {
  try {
    const response = await axios.get(
      API_URL + "/zms/usersdeleted",
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error occurred during retrieving user:", error);    
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving user");
  }
};

//get detail user
export const view_user_byId = async (userId) => {
  try {
    const response = await axios.get(
      API_URL + "/zms/users/"+userId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving user");
  }
};

//Create new user
export const create_new_user = async (userObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/users`,
      userObj,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during ]create new user");
  }
};

//get subuser
export const get_subuser_byParentId = async (userId, fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(
      API_URL + "/zms/users/subusers",
      {
        params: {
          userId,
          fieldNames: JSON.stringify(fieldNames)
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving user");
  }
};

//update user by id
export const update_user_ById = async (userId, userInfor) => {
  try {
    const response = await axios.put(
      API_URL + "/zms/users/"+userId,
      userInfor,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update user");
  }
};

// Delete sub user by id
export const delete_subuser_byId = async (userId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/users/`+ userId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete OA Account");
  }
}

//update user password by id
export const update_userPassword_ById = async (userId, passwordObj) => {
  try {
    const response = await axios.post(
      API_URL + "/zms/users/"+userId,
      passwordObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update user password");
  }
};

// List all oa acount by user
export const list_oaaccounts_by_user = async (userId, parentId, fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(
      API_URL + "/zms/accountsByUserId/"+userId,
      {
        params: {
          fieldNames: JSON.stringify(fieldNames),
          parentId: parentId? parentId: '',
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving OA account");
  }
};

// List all oa account of admin
export const list_all_oaaccounts = async (fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(
      API_URL + "/zms/accounts",
      {
        params: {
          fieldNames: JSON.stringify(fieldNames),
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving OA account");
  }
};

// List all oa acount by subuser
export const list_oaaccounts_ofSubusers = async (userId) => {
  try {
    const response = await axios.get(
      API_URL + "/zms/oasubaccountbyuser/"+userId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving OA account");
  }
};

// Create new oa account
export const create_new_oaaccount = async (OAAccountObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/accounts`,
      OAAccountObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during creating OA account");
  }
};

//Update oa account by id
export const update_oaaccount_ById = async (idOAAccount, OAAccountObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/accounts/` + idOAAccount,
      OAAccountObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update OA account");
  }
}

// Delete oa account by id
export const delete_oaaccount_byId = async (OAAccountId, OAId, userId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/accounts/`+ OAAccountId,
      {
        params: {
          OAId,
          userId,
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete OA Account");
  }
}

// Create new oa sub account
export const create_new_oasubaccount = async (OASubAccountObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/oasubaccount`,
      OASubAccountObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during creating connection");
  }
};

//Update oa sub account by id
export const update_oasubaccount_ById = async (idOASubAccount, OASubAccountObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/oasubaccountbyid/` + idOASubAccount,
      OASubAccountObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update connection");
  }
}

// Delete oa sub account by id
export const delete_oasubaccount_byId = async (OASubAccountId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/oasubaccountbyid/`+ OASubAccountId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete Connection");
  }
}

// Create new Campaign
export const create_new_campaign = async (campaignObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/campaigns`,
      campaignObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during creating Campaign");
  }
};

//Get all campaigns
export const list_all_campaigns = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/campaigns`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving Campaigns");
  }
};

//Get campaign by id
export const view_campaignById = async (idCampaign) => {
  try {

    const response = await axios.get(API_URL+"/zms/campaigns/"+ idCampaign, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const [data] = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving Campaign");
  }
};

//Update campaign by id
export const update_campaignById = async (idCampaign, campaignObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/campaigns/` + idCampaign,
      campaignObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update campaign");
  }
}

// Delete campaign
export const delete_campaign_byId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/campaigns/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete Campaign");
  }
}

// Create new campaign payrolls
export const create_new_campaignpayrolls = async (campaignObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/campaignspayrolls`,
      campaignObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during creating Campaign");
  }
};

//Get all campaigns payrolls
export const list_all_campaignspayrolls = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/campaignspayrolls`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving Campaigns");
  }
};

// Delete campaign payrolls
export const delete_campaignpayrolls_byId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/campaignspayrolls/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete Campaign");
  }
}

// Get all Contacts
export const list_all_contacts = async (userId) => {
  try {
    const response = await axios.get(API_URL + "/zms/contacts", {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all contacts");
  }
};

//Get all contacts on zalo 
export const list_all_contacts_on_zalo = async (userId, parentId, OAId) => {
  try {
    const response = await axios.get(API_URL + `/zms/zalo/contacts`, {
      params: {
        userId,
        parentId: parentId? parentId: '',
        OAId: OAId? OAId: ''
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all contacts");
  }
};

// Get all zalogroups
export const list_all_zalogroups = async (userId) => {
  try {
    const response = await axios.get(API_URL + "/zms/groups", {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all groups");
  }
};

//Get all groups on zalo 
export const list_all_groups_on_zalo = async (userId, parentId, OAId) => {
  try {
    const response = await axios.get(API_URL + `/zms/zalo/groups`, {
      params: {
        userId,
        parentId: parentId? parentId: '',
        OAId: OAId? OAId: ''
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all groups");
  }
};

//Delete group
export const delete_zalogroup_byID = async (idgroup) => {
  try {
    const response = await axios.delete(API_URL + '/zms/groups/'+ idgroup, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete group");
  }
}

// Get all Contact by conditions
export const list_contacts_by_conditions = async (conditions) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/contacts/search`,
      conditions,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all contacts");
  }
};

//Delete Contact
export const delete_contact_byID = async (idContact) => {
  try {
    const response = await axios.delete(API_URL + '/zms/contacts/'+ idContact, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete contact");
  }
}

// Create New Message
export const create_new_message = async (message) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/messages`, {message},
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create message");
  }
};

//Get all messages
export const list_all_messages = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/messages`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

//Get all billing messages
export const list_all_success_messages = async (userId, parentId) => {
  try {
    const response = await axios.get(API_URL+`/zms/successmessages`, {
      params: {
        userId,
        parentId: parentId? parentId: '' 
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

//Get messages by campaign id
export const list_messages_byCmpId = async (campaignId) => {
  try {

    const response = await axios.get(API_URL+"/zms/messagesByCmpId/" + campaignId, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

//Update message by id
export const update_message_byId = async (msgId, message) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/messages/`+ msgId,
      {message},
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ||  "Error occurred during update message");
  }
}

// Delete message by id
export const delete_message_byId = async (messageId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/messages/`+ messageId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete message");
  }
}

// Delete message by campaign id
export const delete_message_byCmpId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/messagesByCmpId/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete message");
  }
}

//Get all messages payrolls
export const list_all_messagespayrolls = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/messagespayrolls`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

//Get all success messages payrolls
export const list_all_success_messagespayrolls = async (userId, parentId) => {
  try {
    const response = await axios.get(API_URL+`/zms/successmessagespayrolls`, {
      params: {
        userId,
        parentId: parentId? parentId: '' 
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

// Create New Messages Payrolls
export const create_new_messagespayrolls = async (message) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/messagespayrolls`, {message},
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create message");
  }
};

// Delete messagespayrolls by id
export const delete_messagespayrolls_byCmpId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/messagespayrollsByCmpId/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete message");
  }
}

// Send Now
export const send_now = async (campaignId, userId, accountId) => {
  try {
    const response = await axios.post(
      "https://hook.eu1.make.com/au7b45mdtvbz5we949e3gd92jp0hj8um",
      {
        campaignId,
        userId,
        accountId,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw error;
  }
};

//List all segments
export const list_all_segments = async (userId) => {
  try {

    const response = await axios.get(API_URL + '/zms/segments', {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })

    return response.data
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all segment");
  }
} 

//list all segments and contacts
export const list_all_segmentsAndCotacts = async () => {
  try {

    const response = await axios.get(API_URL + '/zms/conditions', {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })
    
    return response.data
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all segments and contacts");
  }
}

//Create new contact segment
export const create_new_contactSegments = async (contactSegmentsObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/conditions`,
      contactSegmentsObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create new contact segment");
  }
};

export const update_contactSegments = async (id, contactSegmentsObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/conditions/${id}`,
      contactSegmentsObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create new contact segment");
  }
};

//Create new segment
export const create_new_segment = async (segmentsObj) => {
  try {
    const response = await axios.post(API_URL + `/zms/segments`, segmentsObj, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create new segment");
  }
};

//view segment
export const view_segment = async (segmentsId) => {
  try {
    const response = await axios.get(API_URL + `/zms/segments/${segmentsId}`, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get segment");
  }
};

//update segment
export const update_segment = async (id, segmentsObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/segments/${id}`,
      segmentsObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update segment");
  }
};

export const delete_segment = async (id) => {
  try {
    const response = await axios.delete(API_URL + `/zms/segments/${id}`, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete segment");
  }
};

//Create new segment details
export const create_new_segmentsDetails = async (segmentDetailsObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/segmentsDetails`,
      segmentDetailsObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create new segment details");
  }
};

//view segment detail
export const view_segmentDetails = async (segmentId) => {
  try {
    const response = await axios.get(
      API_URL + `/zms/segmentsDetails/${segmentId}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get segment detail");
  }
};

export const update_segmentDetails = async (id, segmentDetailsObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/segmentsDetails/${id}`,
      segmentDetailsObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update new segment details");
  }
};

export const update_segmentbyContactsTags = async (userId) => {
  try {
    const response = await axios.get(
      API_URL + `/zms/segmentsbycontactstags/${userId}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during update new segment details");
  }
};

export const delete_segmentDetails = async (id) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/segmentsDetails/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete segment detail");
  }
};

export const delete_contactsSegment = async (id) => {
  try {
    const response = await axios.delete(API_URL + `/zms/conditions/${id}`, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete contact segment");
  }
};

// Get all Contact by segmentId
export const list_contacts_by_segmentId = async (segmentId) => {
  try {
    const response = await axios.get(API_URL + `/zms/conditions/${segmentId}`, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get contacts by segmentId");
  }
};


//Create a template
export const create_new_template = async (templateObj, endPoint) => {
  try {
    const response = await axios.post(API_URL+`/zms/templates/${endPoint}`,
      templateObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
    })
    const data = response.data;
    return data;    
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during create new ${endPoint} template`);
  }
}

//Get all template
export const list_all_templates = async (endPoint, userId) => {
  try {
    const response = await axios.get(API_URL + `/zms/templates/${endPoint}?userId=${userId}`, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get all ${endPoint} template`);
  }
};

// Get template By ID
export const view_templateById = async (idTpl, endPoint) => {
  try {
    const response = await axios.get(
      API_URL + `/zms/templates/${endPoint}/` + idTpl,{
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const [data] = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get ${endPoint} template`);
  }
};

//Update template By ID
export const update_templateById = async (idTpl, templateObj, endPoint) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/templates/${endPoint}/` + idTpl,
      templateObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during update ${endPoint} template`);
  }
}

//Delete template
export const delete_templateByID = async (idTpl, endPoint) => {
  try {

    const response = await axios.delete(API_URL+`/zms/templates/${endPoint}/`+idTpl, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })

    const data = response.data;
    return data; 
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during delete ${endPoint} template`);
  }
}

//Upload file => server
export const uploadFiles = async (files) => {
  try{
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    const response =  await axios.post(API_URL+'/upload/cloud/files',formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            access_token: localStorage.getItem('access_token'),
          }
    });
    const {urls} = response.data;
    const data = urls.map((url, i) => ({name: files[i].name, url}));
    return data;
  }
  catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during uploading file");
  }
}

//Delete uploaded file from server
export const deleteFiles = async (fileNames) => {
  try{
    const response =  await axios.delete(API_URL+'/upload/cloud/files',{
        data: {file_names: fileNames},
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        }
    });
    const data = response.data;
  }
  catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during deleting file");
  }
}

//Retrieving file token
export const getFileToken = async (fileUrl, fileName, accountId) => {
  try{
    const response =  await axios.post(API_URL+'/upload/zalo/file',{fileUrl, fileName, accountId},{
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        }
    });
    const data = response.data;
    return data.token;
  }
  catch (error) {
    throw new Error(error?.response?.data?.message || "Error while retrieving file token");
  }
}

//export excel to pdf
export const exportPdfs = async (excelObj) => {
  try{
    const response =  await axios.post(API_URL+'/export/pdfs',excelObj, {
        headers: {
            'Content-Type': 'application/json',
            access_token: localStorage.getItem('access_token'),
          }
    });
    const data = response.data;
    return data;
  }
  catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during exporting file");
  }
}

//Create a package
export const create_new_package = async (packageObj) => {
  try {
    const response = await axios.post(API_URL+`/zms/packages`,
      packageObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
    })
    const data = response.data;
    return data;    
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during create new package`);
  }
}

//Get all package
export const list_all_packages = async (fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(API_URL + `/zms/packages`, {
      params: {
        fieldNames: JSON.stringify(fieldNames)
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get all packages`);
  }
};

// Get package By ID
export const view_packageById = async (idPk, fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(
      API_URL + `/zms/packages/` + idPk,{
        params: {
          fieldNames: JSON.stringify(fieldNames)
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const [data] = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get package`);
  }
};

//Update package By ID
export const update_packageById = async (idPk, packageObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/packages/` + idPk,
      packageObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during update package`);
  }
}

//Delete package
export const delete_packageByID = async (idPk) => {
  try {

    const response = await axios.delete(API_URL+`/zms/packages/`+idPk, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })

    const data = response.data;
    return data; 
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during delete package`);
  }
}


//Create a package OA
export const create_new_packageOA = async (packageObj) => {
  try {
    const response = await axios.post(API_URL+`/zms/packagesoa`,
      packageObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
    })
    const data = response.data;
    return data;    
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during create new package OA`);
  }
}

//Get all packages OA
export const list_all_packagesOA = async (fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(API_URL + `/zms/packagesoa`, {
      params: {
        fieldNames: JSON.stringify(fieldNames)
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get all packages OA`);
  }
};


//Get all packages OA
export const list_packagesOA_byOAId = async (OAId, fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(API_URL + `/zms/packagesoaid`, {
      params: {
        OAId,
        fieldNames: JSON.stringify(fieldNames)
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get packages OA`);
  }
};

// Get package By ID
export const view_packageOAById = async (idPk, fieldNames) => {
  try {
    if(!fieldNames || fieldNames.length === 0) fieldNames = ['*'];
    const response = await axios.get(
      API_URL + `/zms/packagesoa/${idPk}`,{
        params: {
          fieldNames: JSON.stringify(fieldNames)
        },
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const [data] = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during get package OA`);
  }
};

//Update package By ID
export const update_packageOAById = async (idPk, packageObj) => {
  try {
    const response = await axios.put(
      API_URL + `/zms/packagesoa/` + idPk,
      packageObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during update package OA`);
  }
}

//Delete package
export const delete_packageOAByID = async (idPk) => {
  try {
    const response = await axios.delete(API_URL+`/zms/packagesoa/`+idPk, {
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })
    const data = response.data;
    return data; 
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during delete package OA`);
  }
}

export const check_package = async (userId, parentId) => {
  try {
    const response = await axios.get(API_URL+`/zms/packagesoa/checkpackage/`+userId, {
      params:{
        parentId: parentId? parentId: ''
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      }
    })
    const data = response.data;
    return data; 
  } catch (error) {
    throw new Error(error?.response?.data?.message || `Error occurred during check package`);
  }
}

//Get all zns templates on zalo 
export const list_all_znstemplates_on_zalo = async (userId, parentId, OAId) => {
  try {
    const response = await axios.get(API_URL + `/zms/zalo/znstemplate/all`, {
      params: {
        userId,
        parentId: parentId? parentId: '',
        OAId: OAId? OAId: ''
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all zns templates");
  }
};

//Get zns template detail on zalo 
export const list_znstemplate_detail_on_zalo = async (userId, OAId, templateId) => {
  try {
    const response = await axios.get(API_URL + `/zms/zalo/znstemplate/detail`, {
      params: {
        userId,
        OAId: OAId? OAId: '',
        templateId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all zns template detail");
  }
};

//Get all zns templates
export const list_all_znstemplates = async (userId) => {
  try {
    const response = await axios.get(API_URL + `/zms/znstemplates`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    });
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during get all zns templates");
  }
};

// Create new campaign zns
export const create_new_campaignzns = async (campaignObj) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/campaignszns`,
      campaignObj,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during creating Campaign");
  }
};

//Get all campaigns zns
export const list_all_campaignszns = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/campaignszns`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving Campaigns");
  }
};

// Delete campaign zns
export const delete_campaignzns_byId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/campaignszns/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete Campaign");
  }
}

//Get all messages zns
export const list_all_messageszns = async (userId) => {
  try {
    const response = await axios.get(API_URL+`/zms/messageszns`, {
      params: {
        userId
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

//Get all success messages zns
export const list_all_success_messageszns = async (userId, parentId) => {
  try {
    const response = await axios.get(API_URL+`/zms/successmessageszns`, {
      params: {
        userId,
        parentId: parentId? parentId: '' 
      },
      headers: {
        "Content-Type": "application/json",
        access_token: localStorage.getItem('access_token'),
      },
    })

    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during retrieving messages");
  }
};

// Create New Messages zns
export const create_new_messageszns = async (message) => {
  try {
    const response = await axios.post(
      API_URL + `/zms/messageszns`, {message},
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during create message");
  }
};

// Delete messageszns by id
export const delete_messageszns_byCmpId = async (campaignId) => {
  try {
    const response = await axios.delete(
      API_URL + `/zms/messagesznsByCmpId/`+ campaignId,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem('access_token'),
        },
      }
    );
    const data = response.data;
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Error occurred during delete message");
  }
}

// Export
const api = {
  authorizationUser,
  login,
  signUp,
  verifyOTP,
  verifyPassword,
  resendEmailOTP,
  view_user_all,
  view_user_all_deleted,
  view_user_byId,
  update_user_ById,
  update_userPassword_ById,
  create_new_campaign,
  list_all_campaigns,
  view_campaignById,
  update_campaignById,
  delete_campaign_byId,
  list_all_contacts,
  list_all_contacts_on_zalo,
  list_contacts_by_conditions,
  create_new_message,
  list_all_messages,
  list_messages_byCmpId,
  update_message_byId,
  delete_message_byId,
  list_oaaccounts_by_user,
  create_new_oaaccount,
  update_oaaccount_ById,
  delete_oaaccount_byId,
  delete_message_byCmpId,
  send_now,
  uploadFiles,
  exportPdfs,
  deleteFiles,
  getFileToken,
  delete_contact_byID,
  list_all_segmentsAndCotacts,
  create_new_segment,
  update_contactSegments,
  view_segment,
  update_segment,
  create_new_segmentsDetails,
  view_segmentDetails,
  update_segmentDetails,
  create_new_contactSegments,
  list_contacts_by_segmentId,
  delete_segment,
  delete_segmentDetails,
  delete_contactsSegment,
  list_all_segments,
  create_new_template,
  list_all_templates,
  view_templateById,
  update_templateById,
  delete_templateByID,
  create_new_package,
  list_all_packages,
  view_packageById,
  update_packageById,
  delete_packageByID,
  list_all_packagesOA,
  view_packageOAById,
  update_packageOAById,
  delete_packageOAByID,
  check_package,
  create_new_packageOA,
  list_packagesOA_byOAId,
  list_all_success_messages,
  get_subuser_byParentId,
  create_new_user,
  delete_subuser_byId,
  list_oaaccounts_ofSubusers,
  list_all_oaaccounts,
  create_new_oasubaccount,
  update_oasubaccount_ById,
  delete_oasubaccount_byId,
  create_new_campaignpayrolls,
  list_all_messagespayrolls,
  list_all_campaignspayrolls,
  delete_campaignpayrolls_byId,
  list_all_success_messagespayrolls,
  create_new_messagespayrolls,
  delete_messagespayrolls_byCmpId,
  delete_zalogroup_byID,
  list_all_groups_on_zalo,
  list_all_zalogroups,
  list_all_znstemplates_on_zalo,
  list_znstemplate_detail_on_zalo,
  list_all_znstemplates,
  create_new_campaignzns,
  list_all_campaignszns,
  delete_campaignzns_byId,
  list_all_messageszns,
  list_all_success_messageszns,
  create_new_messageszns,
  delete_messageszns_byCmpId
};

export default api;